import _ from 'lodash';
import { makeUID } from '../../../../helpers';

const getFbPlanLabel = (plan, fbSources) => {
  const { year } = plan;
  const agreement = fbSources.agreements.find((a) => a.id === plan.agreementId);
  const bcCode = fbSources.bcCodes.find((b) => b.id === plan.bcCodeId);
  const funding = fbSources.funding.find((f) => f.id === plan.fundingId);
  return [year, agreement.num, bcCode.fullCode, funding?.name].filter(x => x !== undefined).join(' - ');
};

const getSfPlanLabel = (plan, sfSources) => {
  const { year } = plan;
  const funding = sfSources.funding.find((f) => f.id === plan.fundingId);
  const sf = sfSources.sf.find((s) => s.id === plan.sfSourceId);
  return [year, funding.name, sf.name].join(' - ');
};

export const getBudgetOptions = (portfolio, sources,project = {}) => {
  if(!sources.length) return [];
  const fbSources = sources.find(fs => fs.type === 'fb').sources;
  const sfSources = sources.find(fs => fs.type === 'sf').sources;
  let plansToMap = [
    // ...project?.plans?.filter(p => p.id),
    ...portfolio.plans,
  ];

  plansToMap = _.uniqBy(plansToMap, (p) => (p.type === 'fb'
    ? [p.year, p.agreementId, p.bcCodeId, p.fundingId].join('-')
    : [p.year, p.fundingId, p.sfSourceId].join('-')));

  return plansToMap.map((pp, i) => {
    let label = `${i}`;
    if(pp.type === 'fb' && fbSources)
      label = getFbPlanLabel(pp, fbSources)
    else if(pp.type === 'sf' && sfSources)
      label = getSfPlanLabel(pp, sfSources)
    return { id: pp.id, label, type: pp.type, year:pp.year }
  }); 
}

const findParentPlan = (projPlan, portfolioPlan) => {
  switch (projPlan.type) {
    case 'fb':
      return ['year', 'agreementId', 'bcCodeId', 'fundingId'].every((field) => projPlan[field] === portfolioPlan[field]);
    case 'sf':
      return (['year', 'fundingId', 'sfSourceId'].every((field) => projPlan[field] === portfolioPlan[field]));
    default:
      return false;
  }
};

export const mapDtoPlans = (projPlans, portfolioPlans) => projPlans.map((projPlan) => {
  const foundPortfolioPlan = portfolioPlans
    .filter((portfolioPlan) => portfolioPlan.type === projPlan.type)
    .find((portfolioPlan) => findParentPlan(projPlan, portfolioPlan));

    return {
      id: projPlan.id,
      hash: makeUID(5),
      type: projPlan.type,
      portfolioPlanId: foundPortfolioPlan ? foundPortfolioPlan.id : null,
      sum: projPlan.sum,
      year: foundPortfolioPlan ? foundPortfolioPlan.year : projPlan.year,
    }
  })
